// eslint-disable-next-line import/prefer-default-export
export const COLLATERAL_TITLE = 'Our 2021 PPP loan forgiveness application system is not available at this time. We apologize for the inconvenience.';
export const COLLATERAL_SUBTEXT = 'We are updating our PPP loan system records. Please check back later for updates.';
